import { render, staticRenderFns } from "./UserSelectDropdown.vue?vue&type=template&id=07a91f57&scoped=true&"
import script from "./UserSelectDropdown.vue?vue&type=script&lang=js&"
export * from "./UserSelectDropdown.vue?vue&type=script&lang=js&"
import style0 from "./UserSelectDropdown.vue?vue&type=style&index=0&id=07a91f57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a91f57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCheckbox,VList,VListItem,VListItemAction,VListItemGroup,VMenu,VTextField})
